/* eslint-disable sort-keys */
/* eslint-disable react/no-array-index-key */
import React from 'react'

import useMediaQuery from '../../hooks/useMediaQuery'
import { ContentParser, hasNulls } from '../../utils/helpers'
// eslint-disable-next-line import/no-cycle
import { AccordionItemComponent, Image } from '..'
import richTextRenderer from '../RichTextParser/RichTextParser'
import { Content } from '../Typography'
import {
  accordionStyling,
  categoryImage,
  categoryKicker,
  categoryTitle,
  contentStyling,
  headerHeadingContainer,
  priceCategory,
  priceContainer,
  priceContent,
  pricePosition,
  priceStyling,
  subCategoryTitle,
} from './PriceCategoryComponent.module.css'

const PriceCategoryComponent = ({ category, treatmentsData }) => {
  const isSubCategory = !!treatmentsData.filter(
    (res) => res.isundercategory === category.maincategory?.[0],
  ).length
  const subCategories = treatmentsData.filter(
    (res) => res.isundercategory !== null,
  )
  const mainAltCategories = treatmentsData.filter(
    (res) => res.isundercategory === null,
  )

  const title = category.maincategory || category.heading
  const isDesktop = useMediaQuery('(min-width: 768px)')
  return (
    <div className={priceCategory}>
      {category.image && (
        <Image
          className={`${categoryImage} `}
          src={category?.image?.node.localFile.childImageSharp}
        />
      )}
      <div className={headerHeadingContainer}>
        <div>
          <p className={categoryKicker}>{category.kicker}</p>
          <h2 className={categoryTitle}>{title}</h2>
        </div>
      </div>
      {category.content && (
        <div className={contentStyling}>
          {richTextRenderer(category.content)}
        </div>
      )}
      {isSubCategory &&
        subCategories.map((categoryItem, index) => {
          return (
            <div key={index} className={priceCategory}>
              <h3 className={subCategoryTitle}>{categoryItem.heading}</h3>
              {categoryItem.treatments.nodes.map((treatment, itemIndex) => {
                const priceCards = ContentParser(
                  treatment.treatmentpricingsection,
                  'pricecard',
                ).filter((res) => !hasNulls(Object.values(res)))
                return priceCards.length ? (
                  <div key={itemIndex} className={priceContainer}>
                    <ul>
                      {priceCards.map((card, priceIndex) => {
                        const { pricecardprice, pricecardtitle } = card
                        return isDesktop ? (
                          <li
                            key={`${priceIndex}-${pricecardtitle}`}
                            className={pricePosition}
                          >
                            <Content extraClassName={priceStyling}>
                              {pricecardtitle}
                            </Content>
                            <Content
                              extraClassName={`${priceStyling} ${priceContent}`}
                              renderContent={pricecardprice}
                            />
                          </li>
                        ) : (
                          <AccordionItemComponent
                            key={`${priceIndex}-${pricecardtitle}`}
                            extraContentClassname={accordionStyling}
                            extraTitleClassname={accordionStyling}
                            item={{
                              title: pricecardtitle,
                              content: pricecardprice,
                            }}
                          />
                        )
                      })}
                    </ul>
                  </div>
                ) : null
              })}
            </div>
          )
        })}
      {!isSubCategory &&
        mainAltCategories
          .filter((res) => res.heading === category.heading)
          .map((categoryItem, index) => {
            return (
              <div key={index} className={priceCategory}>
                <h3 className={subCategoryTitle}>{categoryItem.heading}</h3>
                {categoryItem.treatments.nodes.map(
                  (treatment, categoryIndex) => {
                    const priceCards = ContentParser(
                      treatment.treatmentpricingsection,
                      'pricecard',
                    ).filter((res) => !hasNulls(Object.values(res)))
                    return priceCards.length ? (
                      <div key={categoryIndex} className={priceContainer}>
                        <ul>
                          {priceCards.map((card, priceIdx) => {
                            const { pricecardprice, pricecardtitle } = card

                            return isDesktop ? (
                              <li
                                key={`${priceIdx}-${pricecardtitle}`}
                                className={pricePosition}
                              >
                                <Content extraClassName={priceStyling}>
                                  {pricecardtitle}
                                </Content>
                                <Content
                                  extraClassName={`${priceStyling} ${priceContent}`}
                                  renderContent={pricecardprice}
                                />
                              </li>
                            ) : (
                              <AccordionItemComponent
                                key={`${priceIdx}-${pricecardtitle}`}
                                extraContentClassname={accordionStyling}
                                extraTitleClassname={accordionStyling}
                                item={{
                                  title: pricecardtitle,
                                  content: pricecardprice,
                                }}
                              />
                            )
                          })}
                        </ul>
                      </div>
                    ) : null
                  },
                )}
              </div>
            )
          })}
    </div>
  )
}

export default PriceCategoryComponent
